import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/risk-center/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/risk-center",
)({
  component: Page,
});
